<template>
  <div class="key-benefits col col-7">
    <div class="key-benefit">
      <IconLearning class="benefit-icon" />
      <p class="benefit-description">
        Learn data analysis, Python, SQL, machine learning, and AI from <strong>industry experts</strong>.
      </p>
    </div>
    <div class="key-benefit">
      <IconCertificate class="benefit-icon" />
      <p class="benefit-description">
        Earn <strong>accredited certificates</strong> and CPE credits.
      </p>
    </div>
    <div class="key-benefit">
      <IconBriefcase class="benefit-icon" />
      <p class="benefit-description">
        Access <strong>career support</strong>, including coaching sessions, job search assistance, and more.
      </p>
    </div>
    <div class="key-benefit">
      <IconLearningPath class="benefit-icon" />
      <p class="benefit-description">
        Follow a <strong>personalized learning path</strong> that fits your goals and schedule.
      </p>
    </div>
    <div class="key-benefit">
      <IconCoaching class="benefit-icon" />
      <p class="benefit-description">
        Benefit from <strong>1:1 mentorship</strong> and expert guidance.
      </p>
    </div>
    <div class="key-benefit">
      <IconExam class="benefit-icon" />
      <p class="benefit-description">
        Build real <strong>AI and data projects</strong> and practice with interactive exercises.
      </p>
    </div>
    <a class="btn btn-primary btn-lg mobile" href="https://365datascience.com" target="_blank">
      Learn more
    </a>
  </div>
</template>

<script>
import IconLearning from '../../assets/svg/home/icon-learning.svg?vue-component';
import IconLearningPath from '../../assets/svg/home/icon-learning-path.svg?vue-component';
import IconCertificate from '../../assets/svg/home/icon-certificate.svg?vue-component';
import IconCoaching from '../../assets/svg/home/icon-coaching.svg?vue-component';
import IconBriefcase from '../../assets/svg/home/icon-briefcase.svg?vue-component';
import IconExam from '../../assets/svg/home/icon-exam.svg?vue-component';

export default {
  components: {
    IconLearning,
    IconLearningPath,
    IconCertificate,
    IconCoaching,
    IconBriefcase,
    IconExam,
  },
};
</script>

<style scoped lang="scss">
.key-benefits {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: repeat(3, auto);
  grid-auto-flow: column;
  gap: 30px;

  .key-benefit {
    display: flex;
    align-items: flex-start;

    .benefit-icon {
      width: 30px;
      flex-shrink: 0;
      flex-grow: 0;
      margin-right: 12px;
    }

    .benefit-description {
      margin: 0;
      font-size: 18px;
      line-height: 150%;

      strong {
        font-weight: 600;
      }
    }
  }

  .btn-primary.mobile {
    display: none;
  }
}

@include bp($bp-laptop) {
  .key-benefits .key-benefit .benefit-description {
    font-size: 16px;
  }
}

@include bp($bp-mobile) {
  .key-benefits {
    grid-template-columns: 1fr;
    grid-template-rows: none;
    grid-auto-flow: row;

    .key-benefit .benefit-description {
      font-size: 16px;

      strong {
        font-weight: 400;
      }
    }

    .btn-primary.mobile {
      display: block;
    }
  }
}
</style>
